import React, { useState, ReactNode } from 'react';
import { createContext } from 'react';

export interface INomeProdutoProps {
  selectedItems: string[];
  setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>;
  selectedErp: string;
  setSelectedErp: React.Dispatch<React.SetStateAction<string>>;
  selectAtivo: boolean | undefined;
  setSelectAtivo: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  versionFilter: string;
  setVersionFilter: React.Dispatch<React.SetStateAction<string>>;
  hasDependencias: boolean | undefined;
  setHasDependencias: (value: boolean | undefined) => void;
  dependeDe: string[];
  setDependeDe: (value: string[]) => void;
}


export interface IFiltroDataProps {
  dataInicial: string;
  setDataInicial: React.Dispatch<React.SetStateAction<string>>;
  dataFinal: string;
  setDataFinal: React.Dispatch<React.SetStateAction<string>>;
}

export const NomeProdutoContext = createContext<INomeProdutoProps>({
  selectedItems: [],
  setSelectedItems: () => [],
  selectedErp: 'todos',
  setSelectedErp: () => '',
  selectAtivo: true,
  setSelectAtivo: () => undefined,
  versionFilter: '',
  setVersionFilter: () => '',
  hasDependencias: undefined,
  setHasDependencias: (_value: boolean | undefined) => {},
  dependeDe: [],
  setDependeDe: (_value: string[]) => {}
});

export const NomeProdutoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [selectedErp, setSelectedErp] = useState<string>('todos');
  const [selectAtivo, setSelectAtivo] = useState<boolean | undefined>(true);
  const [versionFilter, setVersionFilter] = useState<string>('');
  const [hasDependencias, setHasDependencias] = useState<boolean | undefined>(() => {
    const saved = sessionStorage.getItem('hasDependenciasProdutos');
    return saved ? JSON.parse(saved) : undefined;
  });
  const [dependeDe, setDependeDe] = useState<string[]>(() => {
    const saved = sessionStorage.getItem('dependeDeProdutos');
    return saved ? JSON.parse(saved) : [];
  });

  const handleSetHasDependencias = (value: boolean | undefined) => {
    setHasDependencias(value);
    if (value !== undefined) {
      sessionStorage.setItem('hasDependenciasProdutos', JSON.stringify(value));
    } else {
      sessionStorage.removeItem('hasDependenciasProdutos');
    }
  };

  const handleSetDependeDe = (value: string[]) => {
    setDependeDe(value);
    if (value.length > 0) {
      sessionStorage.setItem('dependeDeProdutos', JSON.stringify(value));
    } else {
      sessionStorage.removeItem('dependeDeProdutos');
    }
  };

  return (
    <NomeProdutoContext.Provider value={{
      selectedItems,
      setSelectedItems,
      selectedErp,
      setSelectedErp,
      selectAtivo,
      setSelectAtivo,
      versionFilter,
      setVersionFilter,
      hasDependencias,
      setHasDependencias: handleSetHasDependencias,
      dependeDe,
      setDependeDe: handleSetDependeDe
    }}>
      {children}
    </NomeProdutoContext.Provider>
  );
};

export const FiltroDataContext = createContext<IFiltroDataProps>({
  dataFinal: '',
  setDataInicial: () => '',
  dataInicial: '',
  setDataFinal: () => ''
});

export const FiltroDataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [dataInicial, setDataInicial] = useState<string>('');
  const [dataFinal, setDataFinal] = useState<string>('');

  return (
    <FiltroDataContext.Provider value={{ dataInicial, setDataInicial, dataFinal, setDataFinal }}>
      {children}
    </FiltroDataContext.Provider>
  );
};



